export default __webpack_public_path__ + "static/media/navigation-menu-closed.766058f1.svg";